"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactRedux = require("react-redux");
var _formik = require("formik");
var _fn = require("@otpusk/apisearch-toolbox/dist/queries/fn");
var _selectors = require("./store/selectors");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var withDatesControlProps = function withDatesControlProps(Component) {
  var WithDatesControlProps = function WithDatesControlProps(_ref) {
    var formik = _ref.formik;
    var values = formik.values,
      setFieldValue = formik.setFieldValue;
    var countryID = values[_fn.QUERY_PARAMS.COUNTRY],
      departuresIDs = values[_fn.QUERY_PARAMS.DEPARTURES];
    var getAvailableDates = (0, _react.useMemo)(function () {
      return (0, _selectors.createGetAvailableDates)(countryID, departuresIDs);
    }, [countryID, departuresIDs]);
    var availableDates = (0, _reactRedux.useSelector)(getAvailableDates);
    var handleChange = (0, _react.useCallback)(function (nextDates) {
      return setFieldValue(_fn.QUERY_PARAMS.DATES, nextDates);
    }, [setFieldValue]);
    return /*#__PURE__*/_react.default.createElement(Component, {
      availableDates: availableDates,
      value: values[_fn.QUERY_PARAMS.DATES],
      onChange: handleChange
    });
  };
  return (0, _formik.connect)(WithDatesControlProps);
};
var _default = exports.default = withDatesControlProps;